import React ,{useState} from 'react';
import { withRouter, Link } from "react-router-dom";
import routes from '../Routes'
import {connect} from 'react-redux'
// import { useState } from "react";
const Header = (props) => {
    
  // alert("header")
const [menuopen,setmenuopen]=useState(false)
    const login = props.login
    const redirectTo =async (path,page) => {
     await setmenuopen(false)
      props.history.push(path);
    }
    const logout = () => {
        localStorage.removeItem("login")
        props.logout();
        redirectTo(routes.home, "home")
    }
return(
    <div className="nav">
        <div className="main-nav">
            <div className="container">
                <div className="row">
                    <div className="nav-left">
                        <div className="logo">
                            <a onClick={()=>{  redirectTo(routes.home, "home")}}>
                                <img src={require("../../images/logo.png")} className="mainlogo" alt="logo"/>
                                <img src={require("../../images/logo-i.png")} className="fixedlogo" alt="logo"/>
                            </a>
                        </div>
                    </div>
                    <div  className={menuopen?"nav-right open":"nav-right"}>
                        <ul>
                            <div className="close-nav">
                                <svg xmlns="http://www.w3.org/2000/svg"  viewBox="0 0 47.971 47.971" onClick={()=>setmenuopen(false)}>
                                    <path d="M28.228,23.986L47.092,5.122c1.172-1.171,1.172-3.071,0-4.242c-1.172-1.172-3.07-1.172-4.242,0L23.986,19.744L5.121,0.88
                                    c-1.172-1.172-3.07-1.172-4.242,0c-1.172,1.171-1.172,3.071,0,4.242l18.865,18.864L0.879,42.85c-1.172,1.171-1.172,3.071,0,4.242
                                    C1.465,47.677,2.233,47.97,3,47.97s1.535-0.293,2.121-0.879l18.865-18.864L42.85,47.091c0.586,0.586,1.354,0.879,2.121,0.879
                                    s1.535-0.293,2.121-0.879c1.172-1.171,1.172-3.071,0-4.242L28.228,23.986z" />
                                </svg>
                            </div>
                            {/* {<li><a href="jobportal.html">Home</a></li>
                            <li><a href="joblist.html">Jobs</a></li>
                            <li><a href="about_us.html">About</a></li>
                            <li><a href="login.html">Contact us</a></li>} */}
                            <li className={props.title==="home"?"active":''} ><Link to={routes.home}>Home</Link></li>
                            <li className={props.title==="job"?"active":''}><Link to={routes.job} >Jobs</Link></li>
                            {/* { <li className={props.title=="candidates"?"active":''}><a onClick={() => redirectTo(routes.candidates, "candidates")}>Candidates</a></li>} */}
                         
                            <li className={props.title==="about"?"active":''}><Link to={routes.about}>About</Link></li>
                            <li className={props.title==="contact"?"active":''}><Link to={routes.contact} >Contact us</Link></li>
                          
                        
                        </ul>
                        <div className="login_signup">
                            <a className="active" onClick={() => {login?logout():redirectTo(routes.login, "login")}}>
                            <svg viewBox="0 0 24 24"><path d="m18.75 9h-.75v-3c0-3.309-2.691-6-6-6s-6 2.691-6 6v3h-.75c-1.24 0-2.25 1.009-2.25 2.25v10.5c0 1.241 1.01 2.25 2.25 2.25h13.5c1.24 0 2.25-1.009 2.25-2.25v-10.5c0-1.241-1.01-2.25-2.25-2.25zm-10.75-3c0-2.206 1.794-4 4-4s4 1.794 4 4v3h-8zm5 10.722v2.278c0 .552-.447 1-1 1s-1-.448-1-1v-2.278c-.595-.347-1-.985-1-1.722 0-1.103.897-2 2-2s2 .897 2 2c0 .737-.405 1.375-1 1.722z"/></svg><span > {login?" Log Out":" Log in"}</span></a>
                            <a  onClick={() => {login?redirectTo(routes.profile, "profile"):redirectTo(routes.signup, "signup")}}>
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                                    <path d="M463.748,48.251c-64.336-64.336-169.013-64.335-233.349,0.001c-43.945,43.945-59.209,108.706-40.181,167.461
                                    L4.396,401.536c-2.813,2.813-4.395,6.621-4.395,10.606V497c0,8.291,6.709,15,15,15h84.858c3.984,0,7.793-1.582,10.605-4.395
                                    l21.211-21.226c3.237-3.237,4.819-7.778,4.292-12.334l-2.637-22.793l31.582-2.974c7.178-0.674,12.847-6.343,13.521-13.521
                                    l2.974-31.582l22.793,2.651c4.233,0.571,8.496-0.85,11.704-3.691c3.193-2.856,5.024-6.929,5.024-11.206V363h27.422
                                    c3.984,0,7.793-1.582,10.605-4.395l38.467-37.958c58.74,19.043,122.381,4.929,166.326-39.046
                                    C528.084,217.266,528.084,112.587,463.748,48.251z M421.313,154.321c-17.549,17.549-46.084,17.549-63.633,0
                                    s-17.549-46.084,0-63.633s46.084-17.549,63.633,0S438.861,136.772,421.313,154.321z"/>
                                </svg>
                                <span> {login?" "+props.login_name:" Sign Up"}</span>
                            </a>
                        </div>
                    </div>
                    <div className="menu-icon" onClick={()=>setmenuopen(true)}>
                        <span></span>
                        <span></span>
                        <span></span>
                    </div>
                </div>
            </div>
        </div>
    </div>
)

    // return (
    //     <div className="nav">
           
           
    //     <div className="nav-top">
    //         <div className="container">
    //             <div className="row">
    //                 <p>Mail To: alexbll1988@gmail.com</p>
    //                 <div className="login_signup">
    //                     <a  className={props.title==="login"?"active":''} onClick={() => {login?logout():redirectTo(routes.login, "login")}}>
    //                         <svg viewBox="0 0 24 24"><path d="m18.75 9h-.75v-3c0-3.309-2.691-6-6-6s-6 2.691-6 6v3h-.75c-1.24 0-2.25 1.009-2.25 2.25v10.5c0 1.241 1.01 2.25 2.25 2.25h13.5c1.24 0 2.25-1.009 2.25-2.25v-10.5c0-1.241-1.01-2.25-2.25-2.25zm-10.75-3c0-2.206 1.794-4 4-4s4 1.794 4 4v3h-8zm5 10.722v2.278c0 .552-.447 1-1 1s-1-.448-1-1v-2.278c-.595-.347-1-.985-1-1.722 0-1.103.897-2 2-2s2 .897 2 2c0 .737-.405 1.375-1 1.722z"/></svg><span>{login?" Log Out":" Log in"}</span></a>
    //                     <a className={(props.title==="signup" || props.title==="profile")?"active":''} onClick={() => {login?redirectTo(routes.profile, "profile"):redirectTo(routes.signup, "signup")}}>
    //                         <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 460.8 460.8"><path d="M230.432,0c-65.829,0-119.641,53.812-119.641,119.641s53.812,119.641,119.641,119.641s119.641-53.812,119.641-119.641
    //                         S296.261,0,230.432,0z"/><path d="M435.755,334.89c-3.135-7.837-7.314-15.151-12.016-21.943c-24.033-35.527-61.126-59.037-102.922-64.784
    //                         c-5.224-0.522-10.971,0.522-15.151,3.657c-21.943,16.196-48.065,24.555-75.233,24.555s-53.29-8.359-75.233-24.555
    //                         c-4.18-3.135-9.927-4.702-15.151-3.657c-41.796,5.747-79.412,29.257-102.922,64.784c-4.702,6.792-8.882,14.629-12.016,21.943
    //                         c-1.567,3.135-1.045,6.792,0.522,9.927c4.18,7.314,9.404,14.629,14.106,20.898c7.314,9.927,15.151,18.808,24.033,27.167
    //                         c7.314,7.314,15.673,14.106,24.033,20.898c41.273,30.825,90.906,47.02,142.106,47.02s100.833-16.196,142.106-47.02
    //                         c8.359-6.269,16.718-13.584,24.033-20.898c8.359-8.359,16.718-17.241,24.033-27.167c5.224-6.792,9.927-13.584,14.106-20.898
    //                         C436.8,341.682,437.322,338.024,435.755,334.89z"/></svg><span>{login?" "+props.login_name:" Sign Up"}</span></a>
    //                 </div>
    //             </div>
    //         </div>
    //     </div>
    //     <div className="main-nav">
    //         <div className="container">
    //             <div className="row">
    //                 <div className="nav-left">
    //                     <div className="logo">
    //                         <Link  to={routes.home}><img src={require("../../images/logo.png")} alt="logo"/></Link>
    //                     </div>
    //                 </div>
    //                 <div  className={menuopen?"nav-right open":"nav-right"}>
    //                     <div className="close-nav">
    //                         <svg xmlns="http://www.w3.org/2000/svg"  viewBox="0 0 47.971 47.971"  onClick={()=>setmenuopen(false)}>
    //                             <path d="M28.228,23.986L47.092,5.122c1.172-1.171,1.172-3.071,0-4.242c-1.172-1.172-3.07-1.172-4.242,0L23.986,19.744L5.121,0.88
    //         c-1.172-1.172-3.07-1.172-4.242,0c-1.172,1.171-1.172,3.071,0,4.242l18.865,18.864L0.879,42.85c-1.172,1.171-1.172,3.071,0,4.242
    //         C1.465,47.677,2.233,47.97,3,47.97s1.535-0.293,2.121-0.879l18.865-18.864L42.85,47.091c0.586,0.586,1.354,0.879,2.121,0.879
    //         s1.535-0.293,2.121-0.879c1.172-1.171,1.172-3.071,0-4.242L28.228,23.986z" />
    //                         </svg>
    //                     </div>
    //                     <ul>
                        
    //                         <li className={props.title==="home"?"active":''} ><Link to={routes.home}>Home</Link></li>
    //                         <li className={props.title==="job"?"active":''}><Link to={routes.job} >Jobs</Link></li>
    //                        {/* { <li className={props.title=="candidates"?"active":''}><a onClick={() => redirectTo(routes.candidates, "candidates")}>Candidates</a></li>} */}
                         
    //                         <li className={props.title==="about"?"active":''}><Link to={routes.about}>About</Link></li>
    //                         <li className={props.title==="contact"?"active":''}><Link to={routes.contact} >Contact us</Link></li>
                          
    //                     </ul>
    //                 </div>
    //                 <div className="menu-icon" onClick={()=>setmenuopen(true)}>
    //                     <span></span>
    //                     <span></span>
    //                     <span></span>
    //                 </div>
    //             </div>
    //         </div>
    //     </div>
    
    //     </div>
    // )
}
const mapStateToProps=(state)=>{
return{login:state.list.login}
}
const mapDispatchToProps = (dispatch) => {
    return {
  logout:()=>{(dispatch({type: "LOGIN_INFO", payload: null}))}   
  
    };
  };
export default connect(mapStateToProps,mapDispatchToProps)(withRouter(Header));